module.exports = __webpack_public_path__ + "img/Logo_EFO.8888591f.png";